// extracted by mini-css-extract-plugin
export var parcelRow = "_qj-0";